define('modules/form_editor/views/toolbar',['require','exports','module','base/view','modules/editor/models/editorstate','i18n','ldsh!../templates/toolbar'],function(require, exports, module) {
  "use strict";
  var BaseView = require("base/view"),
      EditorState = require("modules/editor/models/editorstate"),
      i18n = require("i18n");

  var Controller =  {
    isSaving: false,

    saveForm: function() {
      if (!this.isSaving) {
        var idHasValue = $(".js-element-id").val(),
          idHasValidValue = idHasValue && idHasValue.match(/[A-Z0-9]/gi);

        if (idHasValidValue) {
          this.isSaving = true;
          this.vent.trigger("form:save");
        } else {
          $(".js-label-group-id").addClass("has-error");
        }
      }
    },

    moveUpElement: function() {
      if(!this.isElementSelected){
        return;
      }
      this.vent.trigger("form:moveUp");
    },

    moveDownElement: function() {
      if(!this.isElementSelected){
        return;
      }
      this.vent.trigger("form:moveDown");
    },

    duplicateElement: function() {
      if(!this.isElementSelected){
        return;
      }
      this.vent.trigger("form:duplicate");
    },

    removeElement: function() {
      if(!this.isElementSelected){
        return;
      }
      var deleteText = i18n.t("formEditor.confirmDelete");
      var result = window.confirm(deleteText);
      if(result){
        this.vent.trigger("form:remove");
      }
    },

    addTextInput: function() {
      this.vent.trigger("form:addTextInput");
    },

    addTextArea: function() {
      this.vent.trigger("form:addTextArea");
    },

    addCheckboxGroup: function() {
      this.vent.trigger("form:addCheckboxGroup");
    },

    addRadioButtonGroup: function() {
      this.vent.trigger("form:addRadioButtonGroup");
    },

    addDropDown: function() {
      this.vent.trigger("form:addDropDown");
    },

    addHiddenField: function() {
      this.vent.trigger("form:addHiddenField");
    },

    addPrivacyField: function() {
      this.vent.trigger("form:addPrivacyField");
    },

    addSecurityField: function() {
      this.vent.trigger("form:addSecurityField");
    },

    addTermsField: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addTermsField");
    },

    addTelephoneField: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addTelephoneField");
    },

    addEmailField: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addEmailField");
    },

    addDateDropDown: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addDateDropDown");
    },

    addGenderDropDown: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addGenderDropDown");
    },

    addPasswordField: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addPasswordField");
    },

    addIBANField: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addIBANField");
    },

    addDayDropDown: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addDayDropDown");
    },

    addMonthDropDown: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addMonthDropDown");
    },

    addYearDropDown: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addYearDropDown");
    },

    addFBLoginButton: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addFBLoginButton");
    },

    addLinkedInLoginButton: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addLinkedInLoginButton");
    },

    addGoogleReCaptcha: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addGoogleReCaptcha");
    },

    addSeparator: function(e) {
      e.preventDefault();
      this.vent.trigger("form:addSeparator");
    }
  };

  module.exports = BaseView.extend({
    template: require("ldsh!../templates/toolbar"),
    events: {
      "click .js-save": "saveForm",
      "click .js-move-up": "moveUpElement",
      "click .js-move-down": "moveDownElement",
      "click .js-duplicate": "duplicateElement",
      "click .js-remove": "removeElement",
      "click .js-textinput": "addTextInput",
      "click .js-textarea": "addTextArea",
      "click .js-checkbox": "addCheckboxGroup",
      "click .js-radio": "addRadioButtonGroup",
      "click .js-dropdown": "addDropDown",
      "click .js-hidden": "addHiddenField",
      "click .js-privacy": "addPrivacyField",
      "click .js-security": "addSecurityField",
      "click .js-terms": "addTermsField",
      "click .js-telephone": "addTelephoneField",
      "click .js-email": "addEmailField",
      "click .js-date": "addDateDropDown",
      "click .js-gender": "addGenderDropDown",
      "click .js-password": "addPasswordField",
      "click .js-iban": "addIBANField",
      "click .js-day": "addDayDropDown",
      "click .js-month": "addMonthDropDown",
      "click .js-year": "addYearDropDown",
      "click .js-fblogin": "addFBLoginButton",
      "click .js-linlogin": "addLinkedInLoginButton",
      "click .js-googlecaptcha": "addGoogleReCaptcha",
      "click .js-separator": "addSeparator"
    },

    initialize: function(options) {
      this.vent = options.vent;
      this.isElementSelected = false;
      this.listenTo(this.vent, "select:element", this.onSelectedItemChange);
    },

    helpers: function() {
      return {
        isAdvancedMode: EditorState.get("isAdvancedMode"),
        isAMP: EditorState.getAMPState(),
        isPopup: EditorState.isCurrentStepPopup(),
      };
    },

    onSelectedItemChange: function(model) {
      this.isElementSelected = !!model;
    },

    onShow: function() {
      this.$el.i18n();
    }
  });

  _.extend(module.exports.prototype, Controller);
});

